import def_0 from "./attribute_sets";
import def_1 from "./attributes";
import def_2 from "./bim";
import def_3 from "./color_pairing";
import def_4 from "./document_builder";
import def_5 from "./documents";
import def_6 from "./enclosures";
import def_7 from "./fleetwood_blog";
import def_8 from "./forms";
import def_9 from "./helpers/ArticleItemList";
import def_10 from "./helpers/BimProductGroupModal";
import def_11 from "./helpers/GenericContentSearch";
import def_12 from "./helpers/PfcItem";
import def_13 from "./helpers/ProductItem";
import def_14 from "./helpers/ProductItemList";
import def_15 from "./helpers/Shingle";
import def_16 from "./helpers/ShingleList";
import def_17 from "./helpers/SwoogoEvents";
import def_18 from "./helpers/handle_external_url";
import def_19 from "./helpers/item_list_response";
import def_20 from "./helpers/path_to_content";
import def_21 from "./helpers/query_legacy_products";
import def_22 from "./helpers/retrieveImage";
import def_23 from "./insulation_applications_blog";
import def_24 from "./insulation_industrial_blog";
import def_25 from "./insulation_residential_blog";
import def_26 from "./iss";
import def_27 from "./lumber_blog";
import def_28 from "./newsroom_blog";
import def_29 from "./paroc_articles";
import def_30 from "./paroc_structure_selector";
import def_31 from "./products_enclosure";
import def_32 from "./products_fleetwood";
import def_33 from "./products_insulation";
import def_34 from "./products_paroc";
import def_35 from "./products_pfc";
import def_36 from "./products_roofing";
import def_37 from "./reusable";
import def_38 from "./roofing_blog";
import def_39 from "./shingles";
import def_40 from "./swoogo_events";



export default {
  "attribute_sets": def_0,
  "attributes": def_1,
  "bim": def_2,
  "color_pairing": def_3,
  "document_builder": def_4,
  "documents": def_5,
  "enclosures": def_6,
  "fleetwood_blog": def_7,
  "forms": def_8,
  "helpers": {
    "ArticleItemList": def_9,
    "BimProductGroupModal": def_10,
    "GenericContentSearch": def_11,
    "PfcItem": def_12,
    "ProductItem": def_13,
    "ProductItemList": def_14,
    "Shingle": def_15,
    "ShingleList": def_16,
    "SwoogoEvents": def_17,
    "handle_external_url": def_18,
    "item_list_response": def_19,
    "path_to_content": def_20,
    "query_legacy_products": def_21,
    "retrieveImage": def_22
  },
  "insulation_applications_blog": def_23,
  "insulation_industrial_blog": def_24,
  "insulation_residential_blog": def_25,
  "iss": def_26,
  "lumber_blog": def_27,
  "newsroom_blog": def_28,
  "paroc_articles": def_29,
  "paroc_structure_selector": def_30,
  "products_enclosure": def_31,
  "products_fleetwood": def_32,
  "products_insulation": def_33,
  "products_paroc": def_34,
  "products_pfc": def_35,
  "products_roofing": def_36,
  "reusable": def_37,
  "roofing_blog": def_38,
  "shingles": def_39,
  "swoogo_events": def_40
};